import { useQuery } from '@tanstack/react-query';

import { formatData } from 'components/helpers/reactQuery';

export function useProjectPersonnelsQuery({ params = {}, projectId }) {
  return useQuery({
    queryKey: ['projects', projectId, 'projectPersonnel', params],
    queryFn: async () => {
      const response = await axios.get(
        `/projects/${projectId}/project_personnel`,
        { params },
      );

      return response.data;
    },
    select: (data) =>
      formatData({
        data,
        resourceTypes: [
          'companyRole',
          'personnel',
          'profilePhoto',
          'review',
          'version',
        ],
      }),
  });
}
